import { render, staticRenderFns } from "./ReferralFrom.vue?vue&type=template&id=a970794a"
import script from "./ReferralFrom.vue?vue&type=script&lang=js"
export * from "./ReferralFrom.vue?vue&type=script&lang=js"
import style0 from "./ReferralFrom.vue?vue&type=style&index=0&id=a970794a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports